module.exports = __webpack_public_path__ + "static/media/prepTruckIcon.3d8ee829.png";